import { Subject } from 'rxjs/Subject';
var ErrorHandlerService = /** @class */ (function () {
    function ErrorHandlerService() {
        // Observable string sources
        this.errorMessageSource = new Subject();
        // Observable string streams
        this.errorMessage$ = this.errorMessageSource.asObservable();
    }
    // Service message commands
    ErrorHandlerService.prototype.throwError = function (error) {
        this.errorMessageSource.next(error);
    };
    return ErrorHandlerService;
}());
export { ErrorHandlerService };
//# sourceMappingURL=errorhandler.service.js.map